// extracted by mini-css-extract-plugin
export default {"backdrop":"TimerModal_backdrop__8W8rS","timerModal":"TimerModal_timerModal__iJuPH","timerNumber":"TimerModal_timerNumber__DbJwo"};